
import styled, { css } from 'styled-components'
import { ReactComponent as ChartArrow } from '@dataplace.ai/assets/lib/icons/chartArrow.svg'

export const DataRow = styled.div(({ theme: { palette } }) => css`
    color: ${palette.dark.normal};
    display: flex;
    justify-content: space-between;
    gap: 1rem;
  `)

export const DataTitle = styled.span(({
  theme: {
    typography, palette,
  },
}) => css`
    font-size: ${typography.main.pt_15_bold.fontSize};
    font-weight: ${typography.main.pt_15_bold.fontWeight};
    color: ${palette.black};
  `)

export const DataBox = styled.div(() => css`
    padding-right: 1rem;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.5rem;
    white-space: nowrap;
  `)

export const UniqueTraffic = styled.span(({
  theme: {
    typography, palette,
  },
}) => css`
    font-size: ${typography.big.pt_28_bold.fontSize};
    font-weight: ${typography.big.pt_28_bold.fontWeight};
    color: ${palette.black};
    white-space: nowrap;
  `)

export const IndicatorBox = styled.div<{diff: number}>(({
  theme: {
    typography, palette,
  },
  diff,
}) => css`
    font-size: ${typography.small.pt_13_medium.fontSize};
    font-weight: ${typography.small.pt_13_medium.fontWeight};
    color: ${diff > 0 ? palette.results.green.light : diff < 0 ? palette.results.red.light : palette.dark.normal};
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: default;
    gap: 0.3rem;
    white-space: nowrap;
  `)

export const StyledChartArrow = styled(ChartArrow)<{diff: number}>(({ diff }) => (diff < 0
  ? css`
    transform: scaleY(-1);
    transform-origin: center;
  `
  : undefined))
